import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import FormFields from '../../components/FormComponents/FormFields';
import Consent from '../CommunicationConsent';
import  './index.css';

function SwmcOfferCongrats() {
  const location = useLocation();
  const navigate = useNavigate();

  const [appointment, setAppointment] = useState(false);
  const [consent, setConsent] = useState(true);
  const [showConsentSection, setShowConsentSection] = useState(false);
  const [scheduled, setScheduled] = useState(false);
  const [scheduledDate, setScheduledDate] = useState('');
  const [scheduledTime, setScheduledTime] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [formValues, setFormValues] = useState(null);
  const [verifiedData, setVerifiedData] = useState({
    lastName: '',
    fileNumber: '',
    propState: ''
  });

  // Modified useEffect to properly get and store data from both sources
  useEffect(() => {
    console.log("Location state:", location.state);
    
    // Get data from location.state if available
    if (location.state) {
      const lastNameFromState = location.state.lastName || '';
      const fileNumberFromState = location.state.loanNumber || '';
      const propStateFromState = location.state.propState || '';
      
      console.log("Data from location.state:", {
        lastName: lastNameFromState,
        fileNumber: fileNumberFromState,
        propState: propStateFromState
      });
      
      // Store in state
      setVerifiedData({
        lastName: lastNameFromState,
        fileNumber: fileNumberFromState,
        propState: propStateFromState
      });
      
      // Also store in sessionStorage as backup
      sessionStorage.setItem('validated_last_name', lastNameFromState);
      sessionStorage.setItem('validated_file_number', fileNumberFromState);
      sessionStorage.setItem('validated_prop_state', propStateFromState);
    } else {
      // Try to get from sessionStorage
      const lastNameFromStorage = sessionStorage.getItem('validated_last_name');
      const fileNumberFromStorage = sessionStorage.getItem('validated_file_number');
      const propStateFromStorage = sessionStorage.getItem('validated_prop_state');
      
      console.log("Data from sessionStorage:", {
        lastName: lastNameFromStorage,
        fileNumber: fileNumberFromStorage,
        propState: propStateFromStorage
      });
      
      // If we have data in sessionStorage, use it
      if (lastNameFromStorage && fileNumberFromStorage) {
        setVerifiedData({
          lastName: lastNameFromStorage,
          fileNumber: fileNumberFromStorage,
          propState: propStateFromStorage || ''
        });
      } else {
        // If no data in either location.state or sessionStorage, redirect to offer page
        console.log("No verification data found, redirecting to offer page");
        navigate("/offer");
        return;
      }
    }
    
    // Token verification
    const fetch_token = sessionStorage.getItem("offer_token");
    if (location.state && location.state.token) {
      if (fetch_token !== location.state.token) {
        // Token mismatch
        // We'll still continue if we have validated data
        console.log("Token mismatch, but continuing with validated data");
      } else if (location.state.status && location.state.status[0] !== 'SUCCESS') {
        // Status not SUCCESS
        console.log("Status not SUCCESS, redirecting");
        navigate("/offer");
        return;
      }
    }

    window.scrollTo(0, 0);
  }, [location, navigate]);

  function tConvert(time) {
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    if (time.length > 1) {
      time = time.slice(1);
      time[5] = +time[0] < 12 ? ' AM' : ' PM';
      time[0] = +time[0] % 12 || 12;
    }
    return time.join('');
  }

  const FormatChanger = (date) => {
    let datearray = date.split("-");
    let newdate = datearray[1] + '/' + datearray[2] + '/' + datearray[0];
    return newdate;
  };

  const disablePastDate = () => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();
    return yyyy + "-" + mm + "-" + dd;
  };

  const goBackToFirstPage = () => setShowConsentSection(false);

  const handleConsentCheck = (hasConsent) => {
    setConsent(hasConsent);
  };

  
  // Define formFields with labels and prefilled values
  const formFields = [
    {
      name: "FirstName",
      type: "text",
      placeholder: "First Name*",
      required: true,
      validations: ["required"],
      colProps: { sm: 12 }
    },
    {
      name: "LastName",
      type: "text",
      placeholder: "Last Name*",
      required: true,
      validations: ["required"],
      value: verifiedData.lastName || '',
      colProps: { sm: 12 }
    },
    {
      name: "FileNumber",
      type: "text",
      placeholder: "File Number*",
      required: true,
      validations: ["required"],
      value: verifiedData.fileNumber || '',
      colProps: { sm: 12 }
    },
    {
      name: "PropertyState",
      type: "text",
      placeholder: "Property State*",
      required: true,
      validations: ["required"],
      value: verifiedData.propState || '',
      colProps: { sm: 12 }
    },
    {
      name: "PhoneNumber",
      type: "phone",
      placeholder: "Call Me At*",
      required: true,
      validations: ["required", "phone"],
      colProps: { sm: 12 }
    },
    {
      name: "Email",
      type: "email",
      placeholder: "Enter Email*",
      required: true,
      validations: ["required", "email"],
      colProps: { sm: 12 }
    },
    // Using label type for date field
    
    // Date field without placeholder to not overwrite label
    {
      name: "Date",
      type: "date",
      placeholder: "",
      required: true,
      validations: ["required"],
      min: disablePastDate(),
      colProps: { sm: 8},
      className: "date-input"
    },
    // Using label type for time field
    
    // Time field without placeholder to not overwrite label
    {
      name: "Time",
      type: "time",
      placeholder: "",
      required: true,
      validations: ["required"],
      colProps: { sm: 4 },
      className: "time-input"
    },
    {
      name: "Comments",
      type: "textarea",
      placeholder: "Comments",
      colProps: { sm: 12 }
    }
  ];

  const handleSubmit = async (formData) => {
    // Store form data when first submitted
    if (!showConsentSection) {
      console.log("Storing form data:", formData);
      setFormValues(formData);
      document.getElementById("scroll").scrollIntoView({ behavior: 'smooth' });
      setShowConsentSection(true);
      return;
    }
  
    // Use the stored form values when submitting after consent
    const newData = { ...(formValues || {}) };
    newData.TCPA_Consent_Given = consent ? 'Yes' : 'No';
  
    console.log("Preparing to submit form data:", newData);
    setIsLoading(true);
  
    try {
      const apiFormData = new FormData();
      apiFormData.append("postData", JSON.stringify(newData));
      apiFormData.append('leadSource', 'NET007');
      
      console.log("Form data being sent:", JSON.stringify(newData));
  
      // First API call
      try {
        const requestURL = process.env.REACT_APP_OFFER_BORROWER_MAIL;
        console.log("Sending to borrower mail endpoint:", requestURL);
        const borrowerResponse = await fetch(requestURL, {
          method: 'POST',
          body: apiFormData
        });
        
        if (!borrowerResponse.ok) {
          console.error("Borrower mail API error:", borrowerResponse.status, await borrowerResponse.text());
        } else {
          console.log("Borrower mail sent successfully");
        }
      } catch (borrowerError) {
        console.error("Error sending borrower mail:", borrowerError);
        // Continue to next API even if this one fails
      }
  
      // Second API call
      try {
        const dbrequestURL = process.env.REACT_APP_OFFER_SWMC_MAIL;
        console.log("Sending to SWMC mail endpoint:", dbrequestURL);
        
        // Create a fresh FormData object for this request
        const swmcFormData = new FormData();
        swmcFormData.append("postData", JSON.stringify(newData));
        swmcFormData.append('leadSource', 'NET007');
        
        const swmcResponse = await fetch(dbrequestURL, {
          method: 'POST',
          body: swmcFormData
        });
        
        if (!swmcResponse.ok) {
          console.error("SWMC mail API error:", swmcResponse.status, await swmcResponse.text());
          throw new Error(`SWMC API responded with status ${swmcResponse.status}`);
        } else {
          console.log("SWMC mail sent successfully");
        }
      } catch (swmcError) {
        console.error("Error sending SWMC mail:", swmcError);
        // We'll still proceed to show success as long as one email was sent
      }
  
      // Only format date and time if they exist
      if (newData.Date) {
        setScheduledDate(FormatChanger(newData.Date));
      } else {
        setScheduledDate("your selected date");
      }
      
      if (newData.Time) {
        setScheduledTime(tConvert(newData.Time));
      } else {
        setScheduledTime("your selected time");
      }
      
      // Important: Don't set offer_token_expire to true here
      // as it would cause redirection issues
      
      // Set these states to display the thank you message
      console.log("Setting appointment and scheduled to true");
      setScheduled(true);
      setAppointment(true);
      setShowConsentSection(false);
      
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("There was an error submitting your request. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <article>
      <Helmet>
        <title>LowRates.com by Sun West Mortgage Company, Inc. NMLS 3277 - LowRates Offer</title>
        <meta name="description" content="LowRates offers residential home loan mortgages such as purchase, refinance, property rehabilitation loan, and reverse mortgage." />
        <meta property="og:url" content="https://www.lowrates.com/offer-congrats" />
        <meta property="og:title" content="LowRates.com by Sun West Mortgage Company, Inc. NMLS 3277 - LowRates Offer" />
        <meta property="og:description" content="LowRates offers residential home loan mortgages such as purchase, refinance, property rehabilitation loan, and reverse mortgage." />
        <meta property="og:keyword" content="low mortgage rates, mortgage offers, home loan offers, purchase mortgage, refinance mortgage, mortgage refinance rates, home loan rates, low interest home loans, competitive mortgage rates, residential mortgage loans, mortgage financing options, apply for mortgage online, compare mortgage rates, FHA home loans, VA mortgage loans, jumbo mortgage rates, first time home buyer mortgage, homeowner refinance offers, trusted mortgage lender, LowRates.com mortgage" />
        <meta property="og:brand" content="LowRates.com by Sun West Mortgage Company, Inc. NMLS 3277 - LowRates Offer" />
        <link rel="preload" href="https://resources.swmc.com/swmc-react-2025/Swmc-offer/swmc-offer.webp" as="image" type="image/webp" fetchPriority="high" />
      </Helmet>

      <div>
        <div className="hero_image_SwmcCong">
          <div id="scroll">
            <h1>Offer</h1>
          </div>
        </div>

        <Container fluid className="pageContainer_SwmcCong">
          <div>
            {/* Debug current state */}
            {console.log("Current state - appointment:", appointment, "scheduled:", scheduled, "verifiedData:", verifiedData)}
            
            {!appointment ? (
              <div>
                <h3>Congratulations! Your file number has been verified</h3>
                <p style={{ fontSize: '15px', maxWidth: '600px', margin: '0 auto' }}>
                  Please fill out the information below to request a call back.
                </p>

                <div id="formContainid_SwmcCong" className="formContainDiv_SwmcCong">
                  {showConsentSection ? (
                    <div className="formClass_SwmcCong">
                      <Consent
                        handleClick1={() => setConsent(true)}
                        handleClick2={() => setConsent(false)}
                        showConsenSection={showConsentSection}
                      />
                      <FormFields
                        fields={[]}
                        onSubmit={handleSubmit}
                        isLoading={isLoading}
                        showConsentSection={showConsentSection}
                        onGoBack={goBackToFirstPage}
                        hasConsent={consent}
                        onConsentChange={handleConsentCheck}
                      />
                    </div>
                  ) : (
                    <div className="formClass_SwmcCong">
                      <FormFields
                        fields={formFields}
                        onSubmit={handleSubmit}
                        isLoading={isLoading}
                        hasConsent={consent}
                        onConsentChange={handleConsentCheck}
                      />
                    </div>
                  )}
                </div>
              </div>
            ) : (
              // Thank you message
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div className="thanksDiv">
                  <h2>Thank you for scheduling a call with us to discuss your mortgage needs!</h2>
                  <h5>We will contact you on {scheduledDate} between {scheduledTime}</h5>
                  <Link to="/offer">Click here to go back to the offer page</Link>
                </div>
              </div>
            )}
          </div>
        </Container>
      </div>
    </article>
  );
}

export default SwmcOfferCongrats;